import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function CreateResponsibleMedicalRecordLinkUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: { patientId: string }) => {
    return await repository.createResponsibleMedicalRecordLink(params)
  }
}
